module.exports = __webpack_public_path__ + "static/media/telethon-shapes-rhs.22cfeb8c.png";